import jQuery from 'jquery';

//* instance jquery
export default jQuery;
